// extracted by mini-css-extract-plugin
export default {"banner":"ImageBanner_banner__zT-23"};